var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};

var _formatDate=require('./formatDate');var DateFormatter=_interopRequireWildcard(_formatDate);
var _attachments=require('./attachments');var attachments=_interopRequireWildcard(_attachments);
var _constants=require('./constants');var constants=_interopRequireWildcard(_constants);
var _defaultChatSettings=require('./default-chat-settings');var defaultChatSettings=_interopRequireWildcard(_defaultChatSettings);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}

exports=_extends({},
attachments,{
DateFormatter:DateFormatter},
constants,
defaultChatSettings);


module.exports=exports;

if(typeof angular!=='undefined'){
angular.
module('inboxCommon',[]).
service('inboxCommon',function(){return exports;});
}


//////////////////
// WEBPACK FOOTER
// ../~/inbox-common/dist/index.js
// module id = 360
// module chunks = 0